<popup-header [dialogRef]="dialogRef" icon="help_outline" text="Add Enabler Item"></popup-header>
<div class="enabler-item-choice-dialog">
  <p>Do you want to create an Enabler Project or an Enabler Product?</p>
  <p class="info-section">
    <span class="material-icons-outlined" aria-hidden="true">info</span>
    <span>
      <b>Info :</b> <br/>
      <b>Def Enabler Project:</b> An Enabler Project refers to an initiative aimed at creating a unique product, service, or result. It is characterized by specific objectives, allocated resources, a defined timeline, and a dedicated organization to achieve the desired outcomes.<br/>
      <b>Def Enabler Product:</b> An Enabler Product refers to a service or solution that is designed, developed, and offered to meet a specific need or demand, and fulfills a value objective.
    </span>
  </p>
  
 <div class="type-buttons">
    <button class="btn btn-secondary" (click)="selectType('project')">
      Enabler Project
    </button>
    <button class="btn btn-primary" (click)="selectType('product')">
      Enabler Product
    </button>
  </div>
</div>

